import { render, staticRenderFns } from "./SupervisorCardSection.vue?vue&type=template&id=3071dcbf&"
import script from "./SupervisorCardSection.vue?vue&type=script&lang=js&"
export * from "./SupervisorCardSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports